import { withInstall } from '@ll-plus/utils'

import InputSearch from './src/input-search.vue'
import Input from './src/input.vue'
import PasswordInput from './src/password-input.vue'

export const LlInput = withInstall(Input)
export const LlInputSearch = withInstall(InputSearch)
export const LlPasswordInput = withInstall(PasswordInput)

export * from './src/input'

declare module 'vue' {
  export interface GlobalComponents {
    LlInput: typeof Input
    LlInputSearch: typeof InputSearch
    LlPasswordInput: typeof PasswordInput
  }
}
